// `PhoneNumber` — E.164 (spec/08-api-design.md §3).
//
// Phone is the default identity method (F-IAM-01), so a number that is stored two ways is a player
// with two accounts. On the wire it is always E.164: a leading `+`, a country calling code, and up
// to fifteen digits in all, with no spaces, hyphens or brackets.
//
// Parsing what a human typed into this shape is `libphonenumber`'s job on the way in, with the
// venue's default region (spec/03 §10) — not this schema's. This is the canonical form only.
import { z } from "../zod.js";
export const E164_PATTERN = /^\+[1-9]\d{1,14}$/;
export const PhoneNumberSchema = z
    .string()
    .regex(E164_PATTERN, 'Expected an E.164 phone number, for example +919876543210')
    .openapi('PhoneNumber', {
    description: 'A phone number in E.164 form: "+" then the country calling code then the number.',
    example: '+919876543210',
});
export function isE164(value) {
    return typeof value === 'string' && E164_PATTERN.test(value);
}
//# sourceMappingURL=phone-number.js.map